export default __webpack_public_path__ + "static/media/Logo-Ford-Signature-BLU-TR.93eb88f8.png";